<script setup>
import { ref } from 'vue'
import { Icon } from '@components'

// const slots = useSlots()

const emit = defineEmits(['click'])

const props = defineProps({
    title: {
        type: String,
        default: 'Accordion'
    },
    leftIcon: {
        type: String,
        default: 'chevronDown'
    },
    isOpen: {
        type: Boolean,
        default: false
    },
})


// const isOpen = ref(false)

const toggleAccordion = () => {
    props.isOpen = !props.isOpen
    emit('click', props.title)
}
</script>

<template>
    <div>
        <!-- default header design -->
        <div @click="toggleAccordion" class="cursor-pointer flex justify-between items-center py-2 px-3 rounded-[6px]" :class="{ 'bg-[#F2F4F7]': props.isOpen }">
            <div class="flex items-center gap-3">
                <Icon :name="props.leftIcon" size="24px" class="text-[#667085]"></Icon>
                <div class="ml-3 text-[#101828] text-lg font-semibold">{{ props.title }}</div>
            </div>

            <Icon name="chevronDown" size="24px" class="text-[#667085] transition-all duration-300" :class="{ 'rotate-180': props.isOpen }" />
        </div>
        <!-- custom header slot -->
        <!-- <slot name="header"></slot> -->

        <!-- content -->
        <div class="mt-3 py-2 pb-4 flex flex-col gap-4" v-if="props.isOpen">
            <slot></slot>
        </div>
    </div>
</template>


<style>

</style>